export { default as VictoryCandlestick } from "./victory-candlestick";
export { default as Candle } from "./candle";


//////////////////
// WEBPACK FOOTER
// ./node_modules/victory-candlestick/es/index.js
// module id = 2727
// module chunks = 0